import type { ComponentPropsWithRef } from 'react';
import type React from 'react';

import { InfoIcon, InfoV2Icon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';

import { useInfoTooltip } from './hooks/useInfoTooltip';

export const InfoTooltip: React.FC<ComponentPropsWithRef<'button'> & { isSunriseEnabled?: boolean; size?: number }> = ({
	children,
	isSunriseEnabled,
	ref,
	size = 18,
	onClick,
	...props
}) => {
	const { translate } = useI18n();
	const { data, actions } = useInfoTooltip();
	const Icon = data.isOpen ? InfoIcon : InfoV2Icon;

	return (
		<Tooltip open={data.isOpen} onOpenChange={actions.setIsOpen} isSunriseEnabled={isSunriseEnabled}>
			<TooltipTrigger
				aria-label={translate('corgi.components.tooltips.info_tooltip.a11y.label')}
				aria-expanded={data.isOpen}
				onClick={(e) => {
					actions.toggleTooltip();
					onClick?.(e);
				}}
				{...props}
			>
				<Icon size={size} className="m-[3px]" />
			</TooltipTrigger>
			<TooltipContent data-qa="tooltip-help-text" className="z-[5001]">
				{children}
			</TooltipContent>
		</Tooltip>
	);
};
